import React, { Component } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap";
import ConfigurationFormWeb from '../components/Account/ConfigurationFormWeb';
import ConfigurationFormPhone from '../components/Account/ConfigurationFormPhone';


class ConfigurationModal extends Component {
    constructor(props){
        super(props);

        this.state = {
            formWeb: true
        };

        this.toggleFormConfiguration = this.toggleFormConfiguration.bind(this);
    }

    toggleFormConfiguration() {
        this.setState({
            formWeb: !this.state.formWeb
        })
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                {
                    this.props.title ?
                        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                        : ""
                }
                <ModalBody>
                    {this.props.content}<br/>
                    {
                        this.props.business !== null && this.props.business.account_setup === 2 ?
                            ""
                            :
                            <div>
                                <div className="d-flex flex-row">
                                    <div className={(this.state.formWeb ? 'title-color' : '')}
                                         onClick={this.toggleFormConfiguration}>
                                        Formulaire web
                                    </div>
                                    <div className={"pl-3" + (!this.state.formWeb ? ' title-color' : '')}
                                         onClick={this.toggleFormConfiguration}>
                                        T&eacute;l&eacute;phone
                                    </div>
                                </div>
                                <hr/>
                                {
                                    this.state.formWeb ?
                                        <ConfigurationFormWeb
                                            getFormData={this.getFormData}
                                            user={this.props.user}
                                            toggle={this.props.toggle}
                                            business={this.props.business}
                                            loadBusiness={this.props.loadCurrentBusiness}
                                        />
                                        :
                                        <ConfigurationFormPhone
                                            getFormData={this.getFormData}
                                            userPhone={this.props.user.phone_number}
                                            toggle={this.props.toggle}
                                            business={this.props.business}
                                            loadBusiness={this.props.loadCurrentBusiness}
                                        />
                                }
                            </div>
                    }
                </ModalBody>
            </Modal>
        );
    };
}

ConfigurationModal.defaultProps = {
    title: false,
    content: "Êtes-vous sur de vouloir effectuer cette action ?",
    isOpen: false,
    toggle: () => {},
    user: null,
    business: null,
    loadCurrentBusiness: () => {}
};

export default ConfigurationModal;



// WEBPACK FOOTER //
// ./src/components/ConfigurationModal.js